import {ApiClient} from '@hconnect/apiclient'
import {ShiftInput} from '@hconnect/common/types'
import {useMutation, useQueryClient, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {map} from 'lodash'

export const ShiftsCreateQueryKey = 'events-load-list'

/**
 * Formats a time string to HH:MM format
 */
const formatTimeHHMM = (time: string | undefined): string => {
  if (!time) return '00:00'
  const parts = time.split(':')
  return parts.slice(0, 2).join(':')
}

type UseShiftsCreateParams = {
  plantId: string
  options?: UseMutationOptions<ShiftInput[], AxiosError, ShiftInput[]>
}

export const useShiftsCreate = ({plantId, options}: UseShiftsCreateParams) => {
  const queryClient = useQueryClient()
  const path = `/shifthandover/${plantId}/shifts`

  return useMutation({
    mutationFn: async (data: ShiftInput[]) => {
      const response = await ApiClient.axiosInstance.post(
        path,
        map(data, (s) => ({...s, start: formatTimeHHMM(s.start), end: formatTimeHHMM(s.end)}))
      )
      return response.data
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries()
      await options?.onSuccess?.(data, variables, context, mutation)
    }
  })
}
